import React from 'react';
import styled from 'styled-components';
import { Fade, AttentionSeeker } from 'react-awesome-reveal';
import { useNavigate } from 'react-router-dom';

// --- STYLED COMPONENTS ---

const CTAContainer = styled.section`
  padding: 6rem 2rem;
  background: #0f172a; /* Deep slate tech background */
  position: relative;
  overflow: hidden;
`;

const DecorativeGlow = styled.div`
  position: absolute;
  top: -50%;
  left: -20%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(37, 99, 235, 0.15) 0%, rgba(0,0,0,0) 70%);
  border-radius: 50%;
  pointer-events: none;
`;

const DecorativeGlowRight = styled(DecorativeGlow)`
  top: auto;
  bottom: -50%;
  left: auto;
  right: -20%;
  background: radial-gradient(circle, rgba(56, 189, 248, 0.1) 0%, rgba(0,0,0,0) 70%);
`;

const CardWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 4rem 3rem;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 3rem;
  align-items: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 3rem 1.5rem;
    gap: 2rem;
  }
`;

const TextContent = styled.div`
  .tag {
    display: inline-block;
    background: rgba(37, 99, 235, 0.2);
    color: #38bdf8;
    padding: 0.5rem 1rem;
    border-radius: 99px;
    font-size: 0.85rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 1.25rem;
    border: 1px solid rgba(56, 189, 248, 0.2);
  }

  h2 {
    color: #ffffff;
    font-size: 2.5rem;
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: 1rem;
    letter-spacing: -0.02em;

    span {
      background: linear-gradient(to right, #38bdf8, #2563eb);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  p {
    color: #94a3b8;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 0px;
  }
`;

const ActionArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const PrimaryButton = styled.a`
  display: inline-block;
  background: #2563eb;
  color: #ffffff;
  padding: 1rem 2.5rem;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 700;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.4);
  transition: all 0.3s ease;
  cursor:pointer;

  &:hover {
    background: #1d4ed8;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.6);
  }
`;

const NoticeText = styled.span`
  color: #64748b;
  font-size: 0.85rem;
  margin-top: 1rem;
  text-align: right;

  @media (max-width: 768px) {
    text-align: center;
  }

  a {
    color: #38bdf8;
    text-decoration: none;
    font-weight: 500;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

// --- COMPONENT IMPLEMENTATION ---

export default function ITCallToAction() {
    const navigate = useNavigate()
  return (
    <CTAContainer>
      <DecorativeGlow />
      <DecorativeGlowRight />
      
      <Fade direction="up" triggerOnce>
        <CardWrapper>
          
          <TextContent>
            <span className="tag">Industrial Training Placements</span>
            <h2>
              Ready to Secure Your <span>Industrial Training</span> Slot?
            </h2>
            <p>
              Join our engineering team, tackle infrastructure challenges, and complete 
              your prerequisite skill accelerator pathway to gain elite technical advantages.
            </p>
          </TextContent>

          <ActionArea>
            <AttentionSeeker effect="pulse" delay={500} triggerOnce>
              <PrimaryButton onClick={()=>navigate('/itapplication')}>
                Apply for Placement
              </PrimaryButton>
            </AttentionSeeker>
            <NoticeText>
              *Requires selective <b>foundational course</b> alignment.
            </NoticeText>
          </ActionArea>

        </CardWrapper>
      </Fade>
    </CTAContainer>
  );
}